import { render, staticRenderFns } from "./collaps.vue?vue&type=template&id=7b11dfd6&scoped=true&"
import script from "./collaps.vue?vue&type=script&lang=js&"
export * from "./collaps.vue?vue&type=script&lang=js&"
import style0 from "./collaps.vue?vue&type=style&index=0&lang=css&"
import style1 from "./collaps.vue?vue&type=style&index=1&id=7b11dfd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b11dfd6",
  null
  
)

export default component.exports